export const API_URL = process.env.VUE_APP_API_URL
export const WS_URL  = process.env.VUE_APP_WS_URL